// HTML5/WHATWG practical email format regex — requires a real, dot-separated domain with a TLD.
// The local part (before @) mirrors the domain part's dot-handling: a dot may only appear
// between two non-dot segments, never leading, trailing, or doubled up.
export const EMAIL_FORMAT_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const EMAIL_FIELDS = ['email', 'secondary_email', 'other_email', 'prof_personal_email', 'prof_work_email'];
